import { createSlice } from "@reduxjs/toolkit";

export const RootState = {
  currentCase: {
    case_number: null,
    claim_number: null,
  },
};

const appSlice = createSlice({
  name: "app",
  initialState: RootState,
  reducers: {
    setCurrentCase: (state, action) => {
      console.log("Setting current case in reducer:", action.payload);
      state.currentCase = action.payload;
    },
    clearCurrentCase: (state) => {
      state.currentCase = {
        case_number: null,
        claim_number: null,
      };
    },
  },
});

export const { setCurrentCase, clearCurrentCase } = appSlice.actions;
export default appSlice.reducer;
